import { useSearchTableFilter } from 'commons-app/hooks/use-search-table-filter.hook';
import { SearchableDropdown } from 'commons/components';
import { CustomField } from 'core/service/custom-fields/custom-field.type';
import { customFieldFilterKeys } from 'core/query-client/keys/custom-field-filter.keys';
import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { DeviceFormCustomField } from 'modules/devices/domain/api/device-form-custom-field.api';
import { DevicesFilterFields } from 'modules/devices/domain/models/index.vm';
import { OperatorsFilterFields } from 'modules/operators/types/operators-filter.type';

interface CustomFieldFilterProps<TFilterFields> {
    customField: CustomField;
    activeFilter: UserCustomFilter<TFilterFields>;
    onApplySelection: (values: string[]) => void;
    fetchFn: (criteria: DeviceFormCustomField) => Promise<string[]>;
}

export const CustomFieldFilter = <TFilterFields extends DevicesFilterFields | OperatorsFilterFields>({
    customField,
    activeFilter,
    onApplySelection,
    fetchFn,
}: CustomFieldFilterProps<TFilterFields>) => {
    const active = activeFilter?.fields?.active;
    const customFieldId = customField.id ?? '';

    const criteria = (searchValue: string) => ({
        value: searchValue,
        active,
        customFieldId,
    });

    const { options, isLoading, dropdownValue, customFilter, handleApply, onValueChange, onClear } =
        useSearchTableFilter({
            queryKey: customFieldFilterKeys.byField(customFieldId),
            criteria,
            fetchFunction: fetchFn,
            getOptionValue: (customFieldName) => customFieldName,
            onApplySelection,
        });

    const activeFilterCustomFields =
        activeFilter?.fields?.customFields?.find((cf) => cf.customFieldId === customFieldId)?.values ?? [];

    return (
        <SearchableDropdown
            name={`custom-field-${customField.id}-filter`}
            options={options}
            placeholder={customField.name}
            value={dropdownValue}
            secondaryValue={activeFilterCustomFields}
            onValueChange={onValueChange}
            onApplySelection={handleApply}
            isLoading={isLoading}
            searchable
            onClear={onClear}
            customFilter={customFilter}
            virtualized
        />
    );
};
